import { API } from 'common/constants/api-urls';
import axios from 'common/requester';

export const EMAIL_TYPE = /** @type {const} */ ({
  PRIVATE: 'private',
  WORK: 'work',
  NONE: 'none'
});

export const EMAIL_STATUS = /** @type {const} */ ({
  VALID: 'valid',
  INVALID: 'invalid',
  DO_NOT_EMAIL: 'do_not_email'
});

/**
 * Partial type definition for ZeroBounce validation result (just what we need right now)
 * @typedef {object} EMailValidationResult
 * @property {string} status
 * @property {string} sub_status
 * @property {boolean} free_email
 */

/**
 * Validates `email` using ZeroBounce
 * @param {string} email
 * @returns {Promise<EMailValidationResult>}
 */
export const validateEmail = async email => {
  try {
    const response = await axios.post(`${API.ZERO_BOUNCE}/validate-email`, {
      email
    });
    return response;
  } catch (error) {
    return {
      status: EMAIL_STATUS.VALID,
      free_email: false,
      sub_status: ''
    };
  }
};
